module.exports = __webpack_public_path__ + "static/media/IMG_3808.JPG - Version 2.d68f0d9c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/IMG_3808.JPG - Version 2.JPG
// module id = 526
// module chunks = 0